import React from 'react';
import PropTypes from 'prop-types';
class Organization extends React.Component {

  static propTypes = {
    afterSelectRow: PropTypes.func.isRequired,
    className: PropTypes.string
  }

  state = {
    visible: false,
    organization: new Monet.UI.Fields.Render({
      name: 'organizations',
      mandatory: false,
      type: 'LOOKUP',
      lookupEntity: 'Organization',
      lookupEntityColumn: 'description',
    },
    this.props.entity 
      ? this.props.entity
      : 'RouteMonitor').render()
  }

  componentDidMount() {
    const el = this.state.organization.rootEl;
    el.children[2].children[0].firstElementChild.placeholder = Monet.I18n.getResourcesByKey('Monet.RouteMonitor.label.searchOrganizations')
    this.state.organization.addListenerToAfterSelectRow(this.search);
    this.refs.organization.appendChild(el);
  }

  componentDidUpdate() {
    if (!this.state.visible) {
      this.state.organization.clear();
    }
    return true;
  }

  search = ({ id }) => {
    const { afterSelectRow } = this.props;
    afterSelectRow('organizationId', id);
  }

  updateState(visible) {
    this.setState({
      ...this.state,
      visible,
    });
  }

  render() {
    const { className } = this.props;
    const display = (this.state.visible) ? 'inline-flex' : 'none';
    const styles = {
      display,
    };
    return (
      <div ref="organization" style={styles} className={className} />
    );
  }
}

Organization.defaultProps = {
  className: ''
};

export default Organization;
